module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/readable-stream/duplex-browser.js
// module id = ../../../../readable-stream/duplex-browser.js
// module chunks = 5